import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IEmptyAlertBehavior } from "../../../../documaker/domain/format/objects";

export interface IEmptyAlertBehaviorPropertyEditable {
  emptyAlertBehavior(): IPropertyEditable<IEmptyAlertBehavior>;
}

export function instanceOfIEmptyAlertBehaviorPropertyEditable(instance: any): instance is IEmptyAlertBehaviorPropertyEditable {
  return instance
      && instance.emptyAlertBehavior
      && instanceOfIPropertyEditable<IEmptyAlertBehavior>(instance.emptyAlertBehavior());
}
